module.exports = __webpack_public_path__ + "static/media/pear.0f8e3bfc.svg";